// Clean vector map: MapLibre GL rendering OpenFreeMap's "positron" style (OpenStreetMap data).
class LocationOsmMap extends HTMLElement {
  async connectedCallback() {
    var address = this.dataset.address;
    if (!address || !window.maplibregl || this.map) return;

    try {
      var response = await fetch(
        'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(address),
        { headers: { Accept: 'application/json' } }
      );
      var results = await response.json();
      if (!results.length) {
        return console.error('OpenStreetMap geocoding found no result for: ' + address);
      }

      var center = [parseFloat(results[0].lon), parseFloat(results[0].lat)];
      var canvas = document.createElement('div');
      canvas.style.cssText = 'width:100%;height:100%;';
      this.replaceChildren(canvas);

      this.map = new maplibregl.Map({
        container: canvas,
        style: 'https://tiles.openfreemap.org/styles/positron',
        center: center,
        zoom: 15,
        scrollZoom: false,
        dragRotate: false,
        pitchWithRotate: false,
        touchPitch: false,
        attributionControl: false
      });
      this.map.touchZoomRotate.disableRotation();
      this.map.addControl(new maplibregl.NavigationControl({ showCompass: false }));
      this.map.addControl(new maplibregl.AttributionControl({ compact: true }));

      var pin = new maplibregl.Marker({ color: '#151515' }).setLngLat(center).addTo(this.map);
      pin.getElement().style.cursor = 'pointer';
      pin.getElement().addEventListener('click', () => window.open(this.dataset.link, '_blank', 'noopener'));

      this.closest('.location__map-container').classList.add('active');
    } catch (error) {
      console.error('OpenStreetMap geocoding failed', error);
    }
  }

  disconnectedCallback() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }
}

if (!customElements.get('location-osm-map')) {
  customElements.define('location-osm-map', LocationOsmMap);
}
